import BasicScreen from "../BasicScreen";

export default BasicScreen;